import * as _ from 'lodash'
import mtz from 'moment-timezone'
import Persistence from './Persistence';

Persistence.setValues()

export class Helper {

   public static cutString (text: string, limit: number) {
    if (text.length > limit) {
            return text.slice(0, limit - 3) + '...';
        }
        return text;
    }

    public static cleanMoney (dollars: number |  string) {

        if(typeof dollars === 'string') {
            dollars = dollars.replace(/[$,]/g, "")
            dollars = Number(dollars)
        }

        return dollars
    }

    public static formatMoney (dollars: number | string) {
        dollars = Helper.cleanMoney(dollars)

        const usdFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return usdFormatter.format(dollars)
    }

    public static formatTime (time: string, tz?: string, format?: string) {

        tz = tz ? tz : Persistence.getTz()
        format = format ? format : 'h:mm a'

        return mtz.tz(time, tz).tz(Persistence.getTz().toString()).format(format)
    }
}
